import React from "react";

import { InputAdornment } from "@mui/material";

import searchIcon from "@src/assets/svg/search_icon.svg";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import TextInput from "@src/sharedComponents/TextInput/TextInput";
import Text from "@src/sharedComponents/Typography/Text";

import DoNotSellActionMenu from "./MenuOptions";

import styles from "./DoNotSellModal.module.css";

const title = "Manage do not sell";
const subtitle =
  "Toggle the switch to mark or unmark a holding as do not sell. Marked holdings will be blocked from trading.";

type Props = {
  tradingGroupName: string;
  markAllSecurities: () => void;
  unmarkAllSecurities: () => void;
  inputValue: string;
  setInputValue: (value: string) => void;
};

const Header = ({
  tradingGroupName,
  markAllSecurities,
  unmarkAllSecurities,
  inputValue,
  setInputValue,
}: Props) => {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.titleSpacing}>
          <Text variant="title2">{title}</Text>
          <DoNotSellActionMenu
            markAllSecurities={markAllSecurities}
            unmarkAllSecurities={unmarkAllSecurities}
          />
          <Text variant="bodySmall" className={styles.badge}>
            {tradingGroupName}
          </Text>
        </div>

        <Text color="textSubtle" variant="body">
          {subtitle}
        </Text>
      </div>
      <div className={styles.textInput}>
        <TextInput
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={"Search securities..."}
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <InputAdornment position={"start"}>
                <img src={searchIcon} alt="Search icon" />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
};

export default Header;

export const HeaderLoadingState = () => (
  <>
    <div className={styles.header}>
      <div className={styles.titleSpacing}>
        <Skeleton width="100px" height="24px" />
        <Skeleton width="100px" height="20px" />
      </div>
      <Skeleton width="100%" height="20px" />
    </div>
    <div className={styles.textInput}>
      <Skeleton width="140px" height="24px" />
    </div>
  </>
);
